<template>
  <div>
    <el-table :data="tableData" border :height="height">
      <el-table-column prop="trainingUnitName" width="120" label="培训单位"></el-table-column>
      <el-table-column prop="libraryClassify" width="80" align="center" label="题库分类"></el-table-column>
      <el-table-column prop="libraryName" width="150" label="题库名称"></el-table-column>
      <el-table-column label="题目类型" width="80" align="center">
        <template slot-scope="scope">
          {{scope.row.optionType === 10 ? '单选' : ''}}
          {{scope.row.optionType === 20 ? '多选' : ''}}
          {{scope.row.optionType === 30 ? '判断题' : ''}}
        </template>
      </el-table-column>
      <el-table-column prop="questionContent" label="题目内容"></el-table-column>
      <el-table-column  label="选项内容">
        <template slot-scope="scope">
          {{scope.row.optionContents ? scope.row.optionContents.join(';&nbsp;&nbsp;&nbsp;&nbsp;'): ''}}
        </template>
      </el-table-column>
      <el-table-column prop="trueAnswer" label="正确答案" width="80" align="center"></el-table-column>
      <el-table-column prop="questionScore" label="分数" width="50" align="center"></el-table-column>
    </el-table>
    <page-util :params="tableParams" @getList="getTopcList({pageNum:tableParams.pageNum})"></page-util>
  </div>
  
</template>
<script>
import  {
  Req_GetTopcList
} from '@/ajax/exam'
import PageUtil from '@/components/Util/PageUtil'
export default {
  data() {
    return {
      tableData: [],
      tableParams: {
        pageNum:1,
        pageSize: 30
      }
    }
  },
  created() {
    this.getTopcList({
      pageNum: this.tableParams.pageNum
    })
  },
  computed: {
    height() {
      return `${window.innerHeight - 240}px`
    }
  },
  methods: {
    getTopcList(params) {
      Req_GetTopcList({
        ...params,
        pageSize: this.tableParams.pageSize
      }).then(res => {
        this.tableData = res.data
        this.tableParams = res
      }).catch(err => this.$catchErr(err))
    }
  },
  components: {
    PageUtil
  }
}
</script>


// WEBPACK FOOTER //
// src/components/TopicStore.vue